module.exports = __webpack_public_path__ + "img/-s-pic_product zdyw_NO 06.19a0286d.svg";